import './info-popup.scss'

(function() {
	document.addEventListener('click', function(e) {
		const toggle = e.target.closest('.js-infoPopupToggle');
		if (toggle) {
			e.preventDefault();
			const expanded = toggle.getAttribute('aria-expanded') === 'true';
			const controlsId = toggle.getAttribute('aria-controls');
			const content = controlsId ? document.getElementById(controlsId) : null;
			if (!content) return;

			if (expanded) {
				toggle.setAttribute('aria-expanded', 'false');
				content.hidden = true;
			} else {
				// Close any other open popups within the same component
				const root = toggle.closest('.a-infoPopup');
				if (root) {
					const otherToggles = root.querySelectorAll('.js-infoPopupToggle[aria-expanded="true"]');
					otherToggles.forEach((t) => {
						const id = t.getAttribute('aria-controls');
						const c = id ? document.getElementById(id) : null;
						if (c) c.hidden = true;
						t.setAttribute('aria-expanded', 'false');
					});
				}

				toggle.setAttribute('aria-expanded', 'true');
				content.hidden = false;
				// Move focus to the content for screen readers; keep tabbable
				content.setAttribute('tabindex', '-1');
				content.focus({ preventScroll: true });
			}
		}
	});

	// Close on Escape and outside click
	document.addEventListener('keydown', function(e) {
		if (e.key !== 'Escape') return;
		const openToggles = document.querySelectorAll('.js-infoPopupToggle[aria-expanded="true"]');
		openToggles.forEach((toggle) => {
			const id = toggle.getAttribute('aria-controls');
			const content = id ? document.getElementById(id) : null;
			if (content) content.hidden = true;
			toggle.setAttribute('aria-expanded', 'false');
			// Return focus to the toggle
			toggle.focus({ preventScroll: true });
		});
	});

	document.addEventListener('click', function(e) {
		const open = document.querySelectorAll('.js-infoPopupToggle[aria-expanded="true"]');
		open.forEach((toggle) => {
			const root = toggle.closest('.a-infoPopup');
			if (!root) return;
			if (!root.contains(e.target)) {
				const id = toggle.getAttribute('aria-controls');
				const content = id ? document.getElementById(id) : null;
				if (content) content.hidden = true;
				toggle.setAttribute('aria-expanded', 'false');
			}
		});
	});
})();